<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.group-size.title' | translate"
  [description]="'organizer.edit.group-size.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="groupSize.dirty"
  [hasInitialValue]="hasInitialValue"
  [previousUrl]="previousUrl"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="validateForm()"
  [skipSaveModal]="true"
>
  <app-form-input-group
    [label]="'organizer.edit.group-size.input.label' | translate"
    [errors]="groupSize.errors"
  >
    <app-form-input
      #content
      [formControl]="groupSize"
      [min]="minimumGroupSize"
      [placeholder]="'organizer.edit.group-size.input.placeholder' | translate"
      [type]="inputType"
    ></app-form-input>
  </app-form-input-group>

  <app-modal-edit-timeslots
    #modalEditTimeslots
    [isLastTimeslot]="isLastTimeslot"
    (updateAllTimeslots)="updateAllTimeslots()"
    (updateTimeslot)="applyToSession()"
    (updateSelectedTimeslots)="updateSelectedTimeslots()"
  >
  </app-modal-edit-timeslots>
</app-organizer-shared-layout-edit-field>
